import React from 'react';
import Paper from '@mui/material/Paper';

type Props = {
  readonly isGenerating: boolean;
  readonly content?: string;
};

const ConfigFileViewer = (props: Props) => {
  const { isGenerating, content } = props;

  if (isGenerating) {
    return <>Generating...</>;
  }

  return (
    <Paper style={{ backgroundColor: '#F5F5F5', padding: 15 }}>
      <span
        style={{
          fontFamily: 'Monospace',
          whiteSpace: 'pre-wrap',
        }}
      >
        {content || 'Empty file'}
      </span>
    </Paper>
  );
};

export default ConfigFileViewer;
